import React, { useRef, useEffect, useState} from 'react';
import { Modal, Alert, Button, Row, Col, Divider, Descriptions } from 'antd';
import Marquee from 'react-fast-marquee';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { getInformacionPaseMedico } from './peticiones';

function PaseMedico (props) {
  const { verPaseMedico, setverPaseMedico, idPaseMedico} = props;
  const modalContentRef = useRef(null);
  const [informacionPaseMedico, setinformacionPaseMedico] = useState({});

  useEffect(() => {
    if(idPaseMedico > 0 && verPaseMedico === true) 
    buscarInformacionPaseMedico(idPaseMedico);
  }, [idPaseMedico, verPaseMedico])
  


  const buscarInformacionPaseMedico = async (idPaseMedico) => {
    const respuesta = await getInformacionPaseMedico({ idPaseMedico });
     // Convertimos las propiedades del objeto a mayúsculas
    const informacionMayusculas = convertirPropiedadesAMayusculas(respuesta[0]);

    setinformacionPaseMedico(informacionMayusculas);
  };
  

  const convertirPropiedadesAMayusculas = (obj) => {
    const nuevoObjeto = {};
  
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const valor = obj[key];
        nuevoObjeto[key] = typeof valor === 'string' ? valor.toUpperCase() : valor;
      }
    }
  
    return nuevoObjeto;
  };
  

  const handlePrint = () => {
    const modalContent = modalContentRef.current;
  
    html2canvas(modalContent, { scale: 2 }).then(canvas => { // Ajustar escala para mejorar calidad
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
  
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
  
      // Definir márgenes
      const margin = 15; // Márgenes de 15 unidades
      const imgWidth = pdfWidth - 2 * margin; // Ajustar el ancho de la imagen basado en los márgenes
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
      // Calcular la posición de la imagen para centrarla con los márgenes
      const x = margin;
      const y = margin;
  
      // Agregar la imagen al PDF en la posición calculada
      pdf.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);
  
      // Guardar el PDF
      pdf.save('pase_medico.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Hubo un problema al generar el PDF. Por favor, inténtelo de nuevo.');
    });
  };
  

  return (
    <div hidden={!verPaseMedico}>
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1050 }}>
        <Alert
          banner
          style={{ backgroundColor: '#FFAD01' }}
          message={
            <Marquee pauseOnHover gradient={false}>
              <>
                <FontAwesomeIcon icon={faWarning} style={{ color: 'white', fontSize: '25px' }} /> &nbsp;
                <b style={{ color: 'white', fontSize: '25px' }}>FAVOR DE LLEVAR ESTE PASE IMPRESO EL DÍA DE LA CITA</b>
              </>
            </Marquee>
          }
        />
      </div>

      <Modal
        width={{
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
        }}
        open={verPaseMedico}
        closeIcon={<></>}
        footer={<><Button type='default' onClick={handlePrint}>Imprimir</Button></>}
        style={{ marginTop: "-20px" }}
      >
        <div ref={modalContentRef}>
          <Row gutter={16}>
            <Col span={24} style={{ textAlign: 'center', width: '100%' }}>
              <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Logo" style={{ maxHeight: 'calc(10vh - 16px)', width: 'auto', display: 'inline' }} />
            </Col>
            <Col span={24}><Divider style={{ backgroundColor: "#9b1c31", height: "3.5px", width: "100%" }} /></Col>
            <Col span={24} style={{ marginTop: 0 }}>
              <Descriptions column={1} className="custom-descriptions" labelStyle={{ fontSize: "18px", color: 'black' }}>
                <Descriptions.Item label={<b>MEDIPASS</b>}>{informacionPaseMedico?.Medipass}</Descriptions.Item>
                <Descriptions.Item label={<b>PACIENTE</b>}>{informacionPaseMedico?.Paciente}</Descriptions.Item>
                <Descriptions.Item label={<b>EMPRESA</b>}>{informacionPaseMedico?.Empresa}</Descriptions.Item>
                <Descriptions.Item label={<b>MÉDICO</b>}>{informacionPaseMedico?.Medico}</Descriptions.Item>
                <Descriptions.Item label={<b>ESPECIALIDAD</b>}>{informacionPaseMedico?.txt_nombre}</Descriptions.Item>
                <Descriptions.Item label={<b>UBICACIÓN</b>}>{informacionPaseMedico?.Ubicacion}</Descriptions.Item>
              </Descriptions>
              <Alert
                style={{ marginTop: "2%" }}
                description={<p style={{ fontSize: "10px", color: "black" }}>ESTE PASE FUE ASIGNADO A <b>{informacionPaseMedico?.parentesco !== 'TITULAR' ? informacionPaseMedico?.txt_atendido : informacionPaseMedico?.Paciente  }</b>, POR LO QUE DEBE DE PRESENTAR LA IDENTIFICACIÓN OFICIAL DEL TITULAR PARA PODER ACCEDER A LA CONSULTA CON EL ESPECIALISTA.</p>}
                type="warning"
                showIcon
              />
              <center><p>Pase generado <b>{moment().format("DD/MM/YYYY")}.</b> Vigencia hasta el <b>{moment().add(1, 'month').format("DD/MM/YYYY")}.</b> </p></center>
            </Col>
          </Row>
        </div>
      </Modal>

      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1050 }}>
        <Alert
          banner
          style={{ backgroundColor: '#FFAD01' }}
          message={
            <Marquee pauseOnHover gradient={false}>
              <FontAwesomeIcon icon={faWarning} style={{ color: 'white', fontSize: '25px' }} /> &nbsp;
              <b style={{ color: 'white', fontSize: '25px' }}>FAVOR DE LLEVAR ESTE PASE IMPRESO EL DÍA DE LA CITA</b>
            </Marquee>
          }
        />
      </div>
    </div>
  );
}

export default PaseMedico;
